import * as React from 'react';

import {Icon} from '.';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const SmallPrinter: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path d="M14.9 0a1.1 1.1 0 0 1 1.094.98L16 1.1V4h1a3 3 0 0 1 2.995 2.824L20 7v7a2 2 0 0 1-1.85 1.995L18 16h-2v1.9a1.1 1.1 0 0 1-.98 1.094L14.9 19H5.1a1.1 1.1 0 0 1-1.094-.98L4 17.9V16H2a2 2 0 0 1-1.995-1.85L0 14V7a3 3 0 0 1 2.824-2.995L3 4h1V1.1A1.1 1.1 0 0 1 4.98.006L5.1 0h9.8ZM14 13H6v4h8v-4Zm3-7H3a1 1 0 0 0-.993.883L2 7v7h2v-1.9a1.1 1.1 0 0 1 .98-1.094L5.1 11h9.8a1.1 1.1 0 0 1 1.094.98l.006.12V14h2V7a1 1 0 0 0-1-1Zm-2 1a1 1 0 0 1 .117 1.993L15 9h-2a1 1 0 0 1-.117-1.993L13 7h2Zm-1-5H6v2h8V2Z" />
    </Icon>
  );
};

export default SmallPrinter;
